import { schema } from "normalizr"

export const userActivitySchema = new schema.Entity(
    "userActivity",
    {},
    {
        idAttribute: "userActivityId",
    }
)

export const levelSchema = new schema.Entity(
    "level",
    {},
    {
        idAttribute: "programActivityId",
    }
)

levelSchema.define({
    activities: new schema.Array(
        {
            level: levelSchema,
            userActivity: userActivitySchema,
        },
        value => (value.level ? "level" : "userActivity")
    ),
})

export const userCallSchema = new schema.Entity(
    "userCall",
    {
        activities: new schema.Array(
            {
                level: levelSchema,
                userActivity: userActivitySchema,
            },
            value => (value.level ? "level" : "userActivity")
        ),
    },
    { idAttribute: "userCallId" }
)
